import AlternativesSeparatorCSS from 'app/common/react/components/growth/unauth/signup/AlternativesSeparator/AlternativesSeparatorCSS';
import ButtonCSS from 'app/common/react/components/growth/unauth/Button/ButtonCSS';
import FullPageSignupCSS from 'app/common/react/components/growth/unauth/signup/FullPageSignup/FullPageSignupCSS';
import GenderCSS from 'app/common/react/components/growth/unauth/signup/Gender/GenderCSS';
import TermsOfServiceCSS from 'app/common/react/components/growth/unauth/signup/TermsOfService/TermsOfServiceCSS';
import TooltipCSS from 'app/common/react/components/growth/unauth/signup/Tooltip/TooltipCSS';

const cssStyles = () =>
  AlternativesSeparatorCSS() +
  GenderCSS() +
  TooltipCSS() +
  TermsOfServiceCSS() +
  ButtonCSS() +
  FullPageSignupCSS();

export default cssStyles;
